<h5 mat-dialog-title>Job Cancellation</h5>
<div mat-dialog-content>
  <form #statusForm="ngForm" (ngSubmit)="saveStatus(statusForm)">
    <div class="form-group row">
      <label for="quote_LostNote" class="col-sm-4 col-form-label">Note</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="quote_LostNote" id="quote_LostNote" rows="3"
                  [(ngModel)]="data.quote_LostNote" #quote_LostNote="ngModel"></textarea>
      </div>
    </div>
    <div class="form-group">
      <button mat-button type="submit" class="btn btn-bidit-submit mr-1">Submit</button>
      <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
    </div>
  </form>
</div>
